import React, { useMemo } from 'react';
import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core';
import { useLanguageContext } from '../languages';
import { AlternateId, AlternateIdNamespaces } from '../../utils/types';

// eslint-disable-next-line quotes
const TABLE_PHRASES = { body: { editRow: { deleteText: 'Are you sure you want to delete this id?' }, emptyDataSourceMessage: "No alternate id's" } };

export const AlternateIds: React.FC<AlternateIdsProps> = (props) => {
	const { onRowAdd, onRowDelete, alternateIds } = props;

	const { tableLocalization } = useLanguageContext();

	const sortedAlternateIds = useMemo(() => [...alternateIds].sort((a, b) => a.namespace.localeCompare(b.namespace)), [alternateIds]);

	return (
		<div style={{ maxWidth: '100%' }}>
			<MaterialTable
				localization={{ ...tableLocalization, ...TABLE_PHRASES }}
				columns={[
					{
						title: 'Namespace',
						field: 'namespace',
						lookup: AlternateIdNamespaces,
						validate: (rowData): boolean => Boolean(rowData.namespace)
					},
					{
						title: 'ID',
						field: 'id',
						render: (row: AlternateId): JSX.Element => <>{row.id.substring(row.id.indexOf(':') + 1)}</>,
						validate: (rowData): boolean => Boolean(rowData.id?.trim())
					}
				]}
				editable={{ onRowAdd, onRowDelete }}
				data={sortedAlternateIds}
				options={{ pageSize: 2, search: false, sorting: false, paging: false }}
				title='Alternate Ids'
				components={{
					Container: (props): JSX.Element => <Paper {...props} data-testid='alternateIds-table' />
				}}
			/>
		</div>
	);
};

type AlternateIdsProps = {
	alternateIds: AlternateId[];
	onRowAdd?: (newData: AlternateId) => Promise<unknown>;
	onRowDelete?: (oldData: AlternateId) => Promise<unknown>;
};

export default AlternateIds;
